import { setCookie, getCookie } from './../helpers/cookies'; 

(() => {
	const impersonationModal = document.querySelector('.impersonation');
	const startImpersonationForms = document.querySelectorAll('form[name="startImpersonation"]');

	const openModal = () => {
		impersonationModal.classList.add('impersonation--opened');
		setCookie('State_ImpersonateModal', 'true');
	};

	const closeModal = () => {
		impersonationModal.classList.remove('impersonation--opened');
		setCookie('State_ImpersonateModal', 'false');
	};

	
	if(impersonationModal) {
		const impersonationToggle = impersonationModal.querySelector('.impersonation__header');
		const isOpened = getCookie('State_ImpersonateModal') === 'true';

		if(isOpened) {
			openModal();
		}

		impersonationToggle.addEventListener('click', () => {
			if(!impersonationModal.classList.contains('impersonation--opened')) {
				openModal();
			} else {
				closeModal();
			}
		});
		
		startImpersonationForms.forEach(form => {
			form.addEventListener('submit', () => {
				setCookie('State_ImpersonateModal', 'true');
			});
		});
	}

})();
